angular.module('mercury.modules.stock.stocktakereport')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.StocktakeReport', {
    url: '/stocktakereport',
    controller: 'StockStocktakeReportChooserCtrl',
    templateUrl: 'modules/stock/stocktakereport/chooser.tpl.html'
  });

  $stateProvider.state('Stock.StocktakeReportView', {
    url: '/stocktakereportview?:startStocktake&:endStocktake',
    controller: 'StockStocktakeReportViewCtrl',
    templateUrl: 'modules/stock/stocktakereport/view.tpl.html',
    data: {
      menuLinkState: 'Stock.StocktakeReport'
    }
  });

  $stateProvider.state('Stock.StocktakeReportView.Received', {
    url: '/received/:itemId/:startTime/:endTime',
    data: {
      menuLinkState: 'Stock.StocktakeReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupreceived.tpl.html',
        controller: 'StockPurchaseorderPopupreceivedCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StocktakeReportView.StockPrice', {
    url: '/price/:itemId/:quantity/:unitName/:unitRatio/:dateFor',
    data: {
      menuLinkState: 'Stock.StocktakeReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktake/pricebox.tpl.html',
        controller: 'StockStocktakePriceboxCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StocktakeReportView.CalculatedUsage', {
    url: '/usage/:itemId/:startTime/:endTime/:unitName/:unitRatio',
    data: {
      menuLinkState: 'Stock.StocktakeReport',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktakereport/calculatedusage.tpl.html',
        controller: 'StockStocktakeReportCalculatedUsageCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });
}]);
